module.exports = __webpack_public_path__ + "02_very_short_grey.f4f91b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_very_short_grey.png
// module id = Yy3Z
// module chunks = 0